import React, { useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import "./App.css";
import ScrollToTop from "./hooks/ScrollToTop";
import Home from "./pages/Home"
import Trading from "./pages/Trading";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <InnerApp />
    </BrowserRouter>
  );
}

function InnerApp() {
  const location = useLocation();
  const nodeRef = useRef(null); // 🔑 ref che passeremo al CSSTransition

  return (
    <Routes>
      <Route
        path="/*"
        element={
          <TransitionGroup>
            <CSSTransition
              key={location.pathname}
              timeout={{ enter: 500, exit: 0 }}
              classNames="fade"
              nodeRef={nodeRef} // 👈 serve per evitare findDOMNode
            >
              <div ref={nodeRef}>
                <Routes>
                  <Route index element={<Home />} />
                  <Route path="home" element={<Home />} />
                  <Route path="trading" element={<Trading />} />
                </Routes>
              </div>
            </CSSTransition>
          </TransitionGroup>
        }
      />
    </Routes>
  );
}

export default App;
